 <template>


        <b-overlay :show="showoverlay" rounded="sm">
            <div>
                <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
                <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
                <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>


                <div class="row row no-gutters py-2 mb-3">
                    <div class="col-md-10 col-sm-12" >
                        <h4 class="atlhr-dashboard-title mt-10">
                            Loan & Advance<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Loan & Advance</span>
                        </h4>
                    </div>
                    <div class="col-md-2 col-sm-12 d-flex align-items-end justify-content-end" >
                        <div class="pl-0 pr-2 company-employee-count" style="height: 31px; position: unset;"></div>
                    </div>
                </div>
                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <loan-application-list  :flg="1" :loan_type=2 ></loan-application-list>
                </template>
                <template v-else>
                    <lock-template ></lock-template>
                </template>

            </div>
        </b-overlay>

</template>
<script>




    export default{
        mounted() {
            this.setTabIndex();
            //this.showoverlay = false;
            setTimeout(this.showContent , 3000);

        },
        props: [ 'readonly'],

        data(){

            return {
                showoverlay : true,
                cu:window.location.href,
                ce : true,
                avatarsrc : null,
                company_id : 0,
                ewtabIndex : 0,
                employee_exists : 'employee-exists',
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],

                isHovered: false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,

                c_flg: 0, // This variable is for reloading public info

            }
        },
        methods:{

            showContent: function()
            {
                this.showoverlay = false;
            },

            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            handleHover(hovered) {

                this.isHovered = hovered
            },

            setTabIndex:function(event)
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/getid')
                    .then(function (response) {

                        if(this.ce == false)
                        {
                            this.ewtabIndex = 0;
                            return;
                        }

                        this.employee_id = response.data;

                            let uri = window.location.href.split('?');
                            if (uri.length == 2)
                            {
                                let vars = uri[1].split('&');
                                let getVars = {};
                                let tmp = '';
                                vars.forEach(function(v){
                                    tmp = v.split('=');
                                    if(tmp.length == 2)
                                        getVars[tmp[0]] = tmp[1];
                                });
                                //console.log(getVars['#']);
                                if(getVars['#'])
                                    this.ewtabIndex = parseInt(getVars['#']);

                            }


                    }.bind(this));

            },
        },
        created: function(){
            //

            //this.getEmployeeData();
            //this.setTabIndex();
        }

    }

</script>
